import { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import {AlertCircle, ArrowRight, GraduationCap, Loader2} from 'lucide-react'
import { lumi } from '@/lib/lumi'
import PhoneInput from '@/components/PhoneInput'
import {
  CURSOS_AROMATERAPIA,
  isCursoAromaterapiaId,
} from '@/data/cursosAromaterapia'

function CursoAromaterapiaInscricao() {
  const { cursoId } = useParams()
  const navigate = useNavigate()
  const curso = isCursoAromaterapiaId(cursoId) ? CURSOS_AROMATERAPIA[cursoId] : null

  const [indicadoPor, setIndicadoPor] = useState('monica')
  const [nome, setNome] = useState('')
  const [whatsapp, setWhatsapp] = useState('')
  const [email, setEmail] = useState('')
  const [enviando, setEnviando] = useState(false)
  const [erro, setErro] = useState('')

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const indicado = params.get('indicado_por')?.trim()
    if (indicado) {
      setIndicadoPor(indicado)
    } else {
      try {
        const stored = sessionStorage.getItem('capacitacao_indicado_por')
        if (stored) setIndicadoPor(stored)
      } catch {
        // ignore
      }
    }
    window.scrollTo(0, 0)
  }, [])

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setErro('')
    if (!curso) return
    if (!nome.trim() || !whatsapp.trim() || !email.trim()) {
      setErro('Preencha todos os campos para continuar.')
      return
    }

    setEnviando(true)
    try {
      const agora = new Date().toISOString()
      const registro = await lumi.entities.capacitacao.create({
        nome: nome.trim(),
        whatsapp: whatsapp.trim(),
        email: email.trim().toLowerCase(),
        origem: 'Curso Aromaterapia',
        cursoId: curso.id,
        indicadoPor,
        statusInscricao: 'Inscrita',
        etapaAtual: 'inscricao',
        dataInscricao: agora,
        aulasCompletas: [],
        certificadoEmitido: false,
        creator: 'public',
        createdAt: agora,
        updatedAt: agora,
      })

      try {
        const id = (registro as any)?._id || (registro as any)?.id || ''
        if (id) sessionStorage.setItem(`curso_${curso.id}_id`, id)
        sessionStorage.setItem(`curso_${curso.id}_whatsapp`, whatsapp.trim())
        sessionStorage.setItem(`curso_${curso.id}_nome`, nome.trim())
        sessionStorage.setItem(`curso_${curso.id}_email`, email.trim())
      } catch {
        // ignore
      }

      navigate(`/cursos/${curso.id}/aulas`)
    } catch (err) {
      console.error('[curso-aromaterapia] erro ao salvar', err)
      setErro('Não foi possível concluir seu cadastro. Tente novamente.')
    } finally {
      setEnviando(false)
    }
  }

  if (!curso) {
    return (
      <div className="min-h-screen bg-[#F8F4EF] flex items-center justify-center px-4">
        <p className="text-[#5F5E5A]">Curso não encontrado.</p>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-[#F8F4EF]">
      <header className="bg-white border-b border-[#EDE0D4] sticky top-0 z-30">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4">
          <p className="font-cormorant text-lg sm:text-xl font-semibold text-[#2D6A4F]">
            Diagnóstico Saúde e Emoções
          </p>
        </div>
      </header>

      <section className="px-4 sm:px-6 pt-12 sm:pt-16 pb-16">
        <div className="max-w-xl mx-auto">
          <div className="text-center mb-8">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#D8F3DC] text-[#2D6A4F] text-xs font-medium mb-4">
              Inscrição gratuita
            </span>
            <h1 className="font-cormorant text-3xl sm:text-4xl font-semibold text-[#2C2C2A] mb-3">
              {curso.titulo}
            </h1>
            <p className="text-[#5F5E5A]">Preencha seus dados para acessar as aulas.</p>
          </div>

          <div className="bg-white rounded-3xl p-6 sm:p-8 border border-[#EDE0D4] shadow-sm">
            <div className="flex items-center gap-3 mb-6">
              <GraduationCap className="text-[#52B788] shrink-0" size={24} />
              <p className="text-[#2C2C2A] text-sm sm:text-base">
                Após o cadastro você entra direto nas aulas.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-sm font-medium text-[#2C2C2A] mb-1.5">
                  Nome completo <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  placeholder="Seu nome completo"
                  required
                  className="w-full px-4 py-3 rounded-xl border border-[#EDE0D4] bg-[#F8F4EF] text-[#2C2C2A] placeholder-[#B08968]/60 focus:outline-none focus:border-[#52B788]"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-[#2C2C2A] mb-1.5">
                  WhatsApp <span className="text-red-500">*</span>
                </label>
                <PhoneInput value={whatsapp} onChange={setWhatsapp} required />
              </div>
              <div>
                <label className="block text-sm font-medium text-[#2C2C2A] mb-1.5">
                  E-mail <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="seu@email.com"
                  required
                  className="w-full px-4 py-3 rounded-xl border border-[#EDE0D4] bg-[#F8F4EF] text-[#2C2C2A] placeholder-[#B08968]/60 focus:outline-none focus:border-[#52B788]"
                />
              </div>

              {erro ? (
                <div className="flex items-start gap-2 bg-red-50 border border-red-200 rounded-xl px-4 py-3 text-sm text-red-700">
                  <AlertCircle size={16} className="shrink-0 mt-0.5" />
                  <span>{erro}</span>
                </div>
              ) : null}

              <button
                type="submit"
                disabled={enviando}
                className="w-full flex items-center justify-center gap-2 bg-[#2D6A4F] text-white font-medium px-6 py-4 rounded-full hover:bg-[#1f4f3a] transition-colors disabled:opacity-60"
              >
                {enviando ? (
                  <>
                    <Loader2 className="animate-spin" size={18} />
                    Processando…
                  </>
                ) : (
                  <>
                    Acessar o curso
                    <ArrowRight size={18} />
                  </>
                )}
              </button>
            </form>

            <p className="text-center text-xs text-[#5F5E5A] mt-5">
              <Link to={`/cursos/${curso.id}`} className="hover:underline">
                Voltar à apresentação
              </Link>
            </p>
          </div>
        </div>
      </section>
    </div>
  )
}

export default CursoAromaterapiaInscricao
